/* src/components/StateRanking/StateRanking.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	init,
	insert_hydration,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { onMount } from 'svelte';
import Icon from '../Icon/Icon.svelte';
import Tooltip from '../Tooltip/Tooltip.svelte';
import { roundFormat } from '../../helpers/svelte/utils/formatters';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	child_ctx[5] = i;
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	child_ctx[5] = i;
	return child_ctx;
}

// (46:8) {#each states.slice(0, 5) as state, index}
function create_each_block_1(ctx) {
	let tr;
	let td0;
	let t0_value = /*index*/ ctx[5] + 1 + "";
	let t0;
	let t1;
	let td1;
	let a;
	let t2_value = /*state*/ ctx[3].name + "";
	let t2;
	let a_href_value;
	let t3;
	let td2;
	let t4_value = roundFormat(/*state*/ ctx[3].paybackPeriod) + "";
	let t4;
	let t5;
	let t6;
	let td3;
	let t7;
	let t8_value = roundFormat(/*state*/ ctx[3].price) + "";
	let t8;
	let t9;
	let td4;
	let t10;
	let t11_value = roundFormat(/*state*/ ctx[3].savings) + "";
	let t11;

	return {
		c() {
			tr = element("tr");
			td0 = element("td");
			t0 = text(t0_value);
			t1 = space();
			td1 = element("td");
			a = element("a");
			t2 = text(t2_value);
			t3 = space();
			td2 = element("td");
			t4 = text(t4_value);
			t5 = text(" years");
			t6 = space();
			td3 = element("td");
			t7 = text("$");
			t8 = text(t8_value);
			t9 = space();
			td4 = element("td");
			t10 = text("$");
			t11 = text(t11_value);
			this.h();
		},
		l(nodes) {
			tr = claim_element(nodes, "TR", { class: true });
			var tr_nodes = children(tr);
			td0 = claim_element(tr_nodes, "TD", { class: true });
			var td0_nodes = children(td0);
			t0 = claim_text(td0_nodes, t0_value);
			td0_nodes.forEach(detach);
			t1 = claim_space(tr_nodes);
			td1 = claim_element(tr_nodes, "TD", { class: true });
			var td1_nodes = children(td1);
			a = claim_element(td1_nodes, "A", { href: true });
			var a_nodes = children(a);
			t2 = claim_text(a_nodes, t2_value);
			a_nodes.forEach(detach);
			td1_nodes.forEach(detach);
			t3 = claim_space(tr_nodes);
			td2 = claim_element(tr_nodes, "TD", { class: true });
			var td2_nodes = children(td2);
			t4 = claim_text(td2_nodes, t4_value);
			t5 = claim_text(td2_nodes, " years");
			td2_nodes.forEach(detach);
			t6 = claim_space(tr_nodes);
			td3 = claim_element(tr_nodes, "TD", { class: true });
			var td3_nodes = children(td3);
			t7 = claim_text(td3_nodes, "$");
			t8 = claim_text(td3_nodes, t8_value);
			td3_nodes.forEach(detach);
			t9 = claim_space(tr_nodes);
			td4 = claim_element(tr_nodes, "TD", { class: true });
			var td4_nodes = children(td4);
			t10 = claim_text(td4_nodes, "$");
			t11 = claim_text(td4_nodes, t11_value);
			td4_nodes.forEach(detach);
			tr_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(td0, "class", "svelte-14dqh1a");
			attr(a, "href", a_href_value = /*state*/ ctx[3].permalink);
			attr(td1, "class", "svelte-14dqh1a");
			attr(td2, "class", "svelte-14dqh1a");
			attr(td3, "class", "svelte-14dqh1a");
			attr(td4, "class", "svelte-14dqh1a");
			attr(tr, "class", "svelte-14dqh1a");
		},
		m(target, anchor) {
			insert_hydration(target, tr, anchor);
			append_hydration(tr, td0);
			append_hydration(td0, t0);
			append_hydration(tr, t1);
			append_hydration(tr, td1);
			append_hydration(td1, a);
			append_hydration(a, t2);
			append_hydration(tr, t3);
			append_hydration(tr, td2);
			append_hydration(td2, t4);
			append_hydration(td2, t5);
			append_hydration(tr, t6);
			append_hydration(tr, td3);
			append_hydration(td3, t7);
			append_hydration(td3, t8);
			append_hydration(tr, t9);
			append_hydration(tr, td4);
			append_hydration(td4, t10);
			append_hydration(td4, t11);
		},
		p(ctx, dirty) {
			if (dirty & /*states*/ 1 && t2_value !== (t2_value = /*state*/ ctx[3].name + "")) set_data(t2, t2_value);

			if (dirty & /*states*/ 1 && a_href_value !== (a_href_value = /*state*/ ctx[3].permalink)) {
				attr(a, "href", a_href_value);
			}

			if (dirty & /*states*/ 1 && t4_value !== (t4_value = roundFormat(/*state*/ ctx[3].paybackPeriod) + "")) set_data(t4, t4_value);
			if (dirty & /*states*/ 1 && t8_value !== (t8_value = roundFormat(/*state*/ ctx[3].price) + "")) set_data(t8, t8_value);
			if (dirty & /*states*/ 1 && t11_value !== (t11_value = roundFormat(/*state*/ ctx[3].savings) + "")) set_data(t11, t11_value);
		},
		d(detaching) {
			if (detaching) detach(tr);
		}
	};
}

// (55:8) {#if showAllStates}
function create_if_block_1(ctx) {
	let each_1_anchor;
	let each_value = /*states*/ ctx[0].slice(5, /*states*/ ctx[0].length);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert_hydration(target, each_1_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*roundFormat, states*/ 1) {
				each_value = /*states*/ ctx[0].slice(5, /*states*/ ctx[0].length);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (56:10) {#each states.slice(5, states.length) as state, index}
function create_each_block(ctx) {
	let tr;
	let td0;
	let t0_value = /*index*/ ctx[5] + 6 + "";
	let t0;
	let t1;
	let td1;
	let a;
	let t2_value = /*state*/ ctx[3].name + "";
	let t2;
	let a_href_value;
	let t3;
	let td2;
	let t4_value = roundFormat(/*state*/ ctx[3].paybackPeriod) + "";
	let t4;
	let t5;
	let t6;
	let td3;
	let t7;
	let t8_value = roundFormat(/*state*/ ctx[3].price) + "";
	let t8;
	let t9;
	let td4;
	let t10;
	let t11_value = roundFormat(/*state*/ ctx[3].savings) + "";
	let t11;
	let t12;

	return {
		c() {
			tr = element("tr");
			td0 = element("td");
			t0 = text(t0_value);
			t1 = space();
			td1 = element("td");
			a = element("a");
			t2 = text(t2_value);
			t3 = space();
			td2 = element("td");
			t4 = text(t4_value);
			t5 = text(" years");
			t6 = space();
			td3 = element("td");
			t7 = text("$");
			t8 = text(t8_value);
			t9 = space();
			td4 = element("td");
			t10 = text("$");
			t11 = text(t11_value);
			t12 = space();
			this.h();
		},
		l(nodes) {
			tr = claim_element(nodes, "TR", { class: true });
			var tr_nodes = children(tr);
			td0 = claim_element(tr_nodes, "TD", { class: true });
			var td0_nodes = children(td0);
			t0 = claim_text(td0_nodes, t0_value);
			td0_nodes.forEach(detach);
			t1 = claim_space(tr_nodes);
			td1 = claim_element(tr_nodes, "TD", { class: true });
			var td1_nodes = children(td1);
			a = claim_element(td1_nodes, "A", { href: true });
			var a_nodes = children(a);
			t2 = claim_text(a_nodes, t2_value);
			a_nodes.forEach(detach);
			td1_nodes.forEach(detach);
			t3 = claim_space(tr_nodes);
			td2 = claim_element(tr_nodes, "TD", { class: true });
			var td2_nodes = children(td2);
			t4 = claim_text(td2_nodes, t4_value);
			t5 = claim_text(td2_nodes, " years");
			td2_nodes.forEach(detach);
			t6 = claim_space(tr_nodes);
			td3 = claim_element(tr_nodes, "TD", { class: true });
			var td3_nodes = children(td3);
			t7 = claim_text(td3_nodes, "$");
			t8 = claim_text(td3_nodes, t8_value);
			td3_nodes.forEach(detach);
			t9 = claim_space(tr_nodes);
			td4 = claim_element(tr_nodes, "TD", { class: true });
			var td4_nodes = children(td4);
			t10 = claim_text(td4_nodes, "$");
			t11 = claim_text(td4_nodes, t11_value);
			td4_nodes.forEach(detach);
			t12 = claim_space(tr_nodes);
			tr_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(td0, "class", "svelte-14dqh1a");
			attr(a, "href", a_href_value = /*state*/ ctx[3].permalink);
			attr(td1, "class", "svelte-14dqh1a");
			attr(td2, "class", "svelte-14dqh1a");
			attr(td3, "class", "svelte-14dqh1a");
			attr(td4, "class", "svelte-14dqh1a");
			attr(tr, "class", "svelte-14dqh1a");
		},
		m(target, anchor) {
			insert_hydration(target, tr, anchor);
			append_hydration(tr, td0);
			append_hydration(td0, t0);
			append_hydration(tr, t1);
			append_hydration(tr, td1);
			append_hydration(td1, a);
			append_hydration(a, t2);
			append_hydration(tr, t3);
			append_hydration(tr, td2);
			append_hydration(td2, t4);
			append_hydration(td2, t5);
			append_hydration(tr, t6);
			append_hydration(tr, td3);
			append_hydration(td3, t7);
			append_hydration(td3, t8);
			append_hydration(tr, t9);
			append_hydration(tr, td4);
			append_hydration(td4, t10);
			append_hydration(td4, t11);
			append_hydration(tr, t12);
		},
		p(ctx, dirty) {
			if (dirty & /*states*/ 1 && t2_value !== (t2_value = /*state*/ ctx[3].name + "")) set_data(t2, t2_value);

			if (dirty & /*states*/ 1 && a_href_value !== (a_href_value = /*state*/ ctx[3].permalink)) {
				attr(a, "href", a_href_value);
			}

			if (dirty & /*states*/ 1 && t4_value !== (t4_value = roundFormat(/*state*/ ctx[3].paybackPeriod) + "")) set_data(t4, t4_value);
			if (dirty & /*states*/ 1 && t8_value !== (t8_value = roundFormat(/*state*/ ctx[3].price) + "")) set_data(t8, t8_value);
			if (dirty & /*states*/ 1 && t11_value !== (t11_value = roundFormat(/*state*/ ctx[3].savings) + "")) set_data(t11, t11_value);
		},
		d(detaching) {
			if (detaching) detach(tr);
		}
	};
}

// (72:8) {:else}
function create_else_block(ctx) {
	let t;

	return {
		c() {
			t = text("Show less states");
		},
		l(nodes) {
			t = claim_text(nodes, "Show less states");
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (70:8) {#if !showAllStates}
function create_if_block(ctx) {
	let t;

	return {
		c() {
			t = text("Show all state rankings");
		},
		l(nodes) {
			t = claim_text(nodes, "Show all state rankings");
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let section;
	let h2;
	let t0;
	let t1;
	let p;
	let t2;
	let t3;
	let div2;
	let div0;
	let table;
	let tr;
	let th0;
	let t4;
	let br;
	let t5;
	let t6;
	let th1;
	let t7;
	let t8;
	let th2;
	let t9;
	let tooltip0;
	let t10;
	let th3;
	let t11;
	let tooltip1;
	let t12;
	let th4;
	let t13;
	let tooltip2;
	let t14;
	let t15;
	let t16;
	let div1;
	let button;
	let t17;
	let icon;
	let current;
	let mounted;
	let dispose;
	tooltip0 = new Tooltip({ props: { text: "For a 5kW system" } });
	tooltip1 = new Tooltip({ props: { text: "For a 5kW system" } });
	tooltip2 = new Tooltip({ props: { text: "For a 5kW system" } });
	let each_value_1 = /*states*/ ctx[0].slice(0, 5);
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let if_block0 = /*showAllStates*/ ctx[1] && create_if_block_1(ctx);

	function select_block_type(ctx, dirty) {
		if (!/*showAllStates*/ ctx[1]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block1 = current_block_type(ctx);

	icon = new Icon({
			props: {
				icon: "chevron-right",
				style: `fill: #2B6CD2;transform: rotate(${/*showAllStates*/ ctx[1] ? '-90deg' : '90deg'});margin-left: 0.25rem`
			}
		});

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			t0 = text("State ranks for solar in the US");
			t1 = space();
			p = element("p");
			t2 = text("We made a list of states ranking for best payback period, prices and savings.");
			t3 = space();
			div2 = element("div");
			div0 = element("div");
			table = element("table");
			tr = element("tr");
			th0 = element("th");
			t4 = text("Overall ");
			br = element("br");
			t5 = text("Rank");
			t6 = space();
			th1 = element("th");
			t7 = text("State");
			t8 = space();
			th2 = element("th");
			t9 = text("Avg. Payback Period\n            ");
			create_component(tooltip0.$$.fragment);
			t10 = space();
			th3 = element("th");
			t11 = text("Avg. System Price\n            ");
			create_component(tooltip1.$$.fragment);
			t12 = space();
			th4 = element("th");
			t13 = text("Avg. 20 Year Savings\n            ");
			create_component(tooltip2.$$.fragment);
			t14 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t15 = space();
			if (if_block0) if_block0.c();
			t16 = space();
			div1 = element("div");
			button = element("button");
			if_block1.c();
			t17 = space();
			create_component(icon.$$.fragment);
			this.h();
		},
		l(nodes) {
			section = claim_element(nodes, "SECTION", { class: true });
			var section_nodes = children(section);
			h2 = claim_element(section_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, "State ranks for solar in the US");
			h2_nodes.forEach(detach);
			t1 = claim_space(section_nodes);
			p = claim_element(section_nodes, "P", {});
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "We made a list of states ranking for best payback period, prices and savings.");
			p_nodes.forEach(detach);
			t3 = claim_space(section_nodes);
			div2 = claim_element(section_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div0 = claim_element(div2_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			table = claim_element(div0_nodes, "TABLE", { class: true });
			var table_nodes = children(table);
			tr = claim_element(table_nodes, "TR", { class: true });
			var tr_nodes = children(tr);
			th0 = claim_element(tr_nodes, "TH", { class: true });
			var th0_nodes = children(th0);
			t4 = claim_text(th0_nodes, "Overall ");
			br = claim_element(th0_nodes, "BR", {});
			t5 = claim_text(th0_nodes, "Rank");
			th0_nodes.forEach(detach);
			t6 = claim_space(tr_nodes);
			th1 = claim_element(tr_nodes, "TH", { class: true });
			var th1_nodes = children(th1);
			t7 = claim_text(th1_nodes, "State");
			th1_nodes.forEach(detach);
			t8 = claim_space(tr_nodes);
			th2 = claim_element(tr_nodes, "TH", { class: true });
			var th2_nodes = children(th2);
			t9 = claim_text(th2_nodes, "Avg. Payback Period\n            ");
			claim_component(tooltip0.$$.fragment, th2_nodes);
			th2_nodes.forEach(detach);
			t10 = claim_space(tr_nodes);
			th3 = claim_element(tr_nodes, "TH", { class: true });
			var th3_nodes = children(th3);
			t11 = claim_text(th3_nodes, "Avg. System Price\n            ");
			claim_component(tooltip1.$$.fragment, th3_nodes);
			th3_nodes.forEach(detach);
			t12 = claim_space(tr_nodes);
			th4 = claim_element(tr_nodes, "TH", { class: true });
			var th4_nodes = children(th4);
			t13 = claim_text(th4_nodes, "Avg. 20 Year Savings\n            ");
			claim_component(tooltip2.$$.fragment, th4_nodes);
			th4_nodes.forEach(detach);
			tr_nodes.forEach(detach);
			t14 = claim_space(table_nodes);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(table_nodes);
			}

			t15 = claim_space(table_nodes);
			if (if_block0) if_block0.l(table_nodes);
			table_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t16 = claim_space(div2_nodes);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			button = claim_element(div1_nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			if_block1.l(button_nodes);
			t17 = claim_space(button_nodes);
			claim_component(icon.$$.fragment, button_nodes);
			button_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "svelte-14dqh1a");
			attr(th0, "class", "svelte-14dqh1a");
			attr(th1, "class", "svelte-14dqh1a");
			attr(th2, "class", "svelte-14dqh1a");
			attr(th3, "class", "svelte-14dqh1a");
			attr(th4, "class", "svelte-14dqh1a");
			attr(tr, "class", "svelte-14dqh1a");
			attr(table, "class", "ranking__table svelte-14dqh1a");
			attr(div0, "class", "ranking__wrapper svelte-14dqh1a");
			attr(button, "class", "svelte-14dqh1a");
			attr(div1, "class", "ranking__button-wrapper svelte-14dqh1a");
			attr(div2, "class", "ranking svelte-14dqh1a");
			attr(section, "class", "container state-ranks svelte-14dqh1a");
		},
		m(target, anchor) {
			insert_hydration(target, section, anchor);
			append_hydration(section, h2);
			append_hydration(h2, t0);
			append_hydration(section, t1);
			append_hydration(section, p);
			append_hydration(p, t2);
			append_hydration(section, t3);
			append_hydration(section, div2);
			append_hydration(div2, div0);
			append_hydration(div0, table);
			append_hydration(table, tr);
			append_hydration(tr, th0);
			append_hydration(th0, t4);
			append_hydration(th0, br);
			append_hydration(th0, t5);
			append_hydration(tr, t6);
			append_hydration(tr, th1);
			append_hydration(th1, t7);
			append_hydration(tr, t8);
			append_hydration(tr, th2);
			append_hydration(th2, t9);
			mount_component(tooltip0, th2, null);
			append_hydration(tr, t10);
			append_hydration(tr, th3);
			append_hydration(th3, t11);
			mount_component(tooltip1, th3, null);
			append_hydration(tr, t12);
			append_hydration(tr, th4);
			append_hydration(th4, t13);
			mount_component(tooltip2, th4, null);
			append_hydration(table, t14);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(table, null);
			}

			append_hydration(table, t15);
			if (if_block0) if_block0.m(table, null);
			append_hydration(div2, t16);
			append_hydration(div2, div1);
			append_hydration(div1, button);
			if_block1.m(button, null);
			append_hydration(button, t17);
			mount_component(icon, button, null);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[2]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*roundFormat, states*/ 1) {
				each_value_1 = /*states*/ ctx[0].slice(0, 5);
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(table, t15);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}

			if (/*showAllStates*/ ctx[1]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(table, null);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (current_block_type !== (current_block_type = select_block_type(ctx, dirty))) {
				if_block1.d(1);
				if_block1 = current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(button, t17);
				}
			}

			const icon_changes = {};
			if (dirty & /*showAllStates*/ 2) icon_changes.style = `fill: #2B6CD2;transform: rotate(${/*showAllStates*/ ctx[1] ? '-90deg' : '90deg'});margin-left: 0.25rem`;
			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tooltip0.$$.fragment, local);
			transition_in(tooltip1.$$.fragment, local);
			transition_in(tooltip2.$$.fragment, local);
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip0.$$.fragment, local);
			transition_out(tooltip1.$$.fragment, local);
			transition_out(tooltip2.$$.fragment, local);
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			destroy_component(tooltip0);
			destroy_component(tooltip1);
			destroy_component(tooltip2);
			destroy_each(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if_block1.d();
			destroy_component(icon);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { states } = $$props;
	let showAllStates = true;

	onMount(() => {
		$$invalidate(1, showAllStates = false);
	});

	const click_handler = () => $$invalidate(1, showAllStates = !showAllStates);

	$$self.$$set = $$props => {
		if ('states' in $$props) $$invalidate(0, states = $$props.states);
	};

	return [states, showAllStates, click_handler];
}

class StateRanking extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { states: 0 });
	}
}

export default StateRanking;